import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { 
    FaCookieBite, 
    FaCog, 
    FaEye, 
    FaShieldAlt,
    FaCheckCircle,
    FaTimesCircle,
    FaEnvelope,
    FaPhone,
    FaGlobe
} from 'react-icons/fa';
import './About.css';
import BannerWithBreadcrumb from '../components/BannerWithBreadcrumb';

const Cookies = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="about-page">
            <BannerWithBreadcrumb
                title="Cookie Policy"
                breadcrumbItems={[
                    { label: 'Home', link: '/' },
                    { label: 'Cookie Policy' }
                ]}
            />
            {/* Cookie Content */}
            <section className="content-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.2 }}
                            >
                                <Card className="privacy-card">
                                    <Card.Body>
                                        <h2>1. What Are Cookies?</h2>
                                        <p>Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience by:</p>
                                        <ul>
                                            <li>Remembering your preferences and settings</li>
                                            <li>Analyzing how you use our website</li>
                                            <li>Providing personalized content and advertisements</li>
                                            <li>Improving our services and user experience</li>
                                        </ul>

                                        <h2>2. Types of Cookies We Use</h2>
                                        
                                        <h3>Essential Cookies</h3>
                                        <p>These cookies are necessary for the website to function properly. They enable basic functions like:</p>
                                        <ul>
                                            <li>User authentication and login</li>
                                            <li>Security features and fraud prevention</li>
                                            <li>Basic website functionality</li>
                                            <li>Session management</li>
                                        </ul>
                                        <p><strong>Note:</strong> These cookies cannot be disabled as they are essential for the website to work.</p>

                                        <h3>Performance Cookies</h3>
                                        <p>These cookies help us understand how visitors interact with our website by:</p>
                                        <ul>
                                            <li>Collecting information about which pages you visit</li>
                                            <li>Identifying any errors that occur</li>
                                            <li>Measuring website performance and speed</li>
                                            <li>Understanding user behavior patterns</li>
                                        </ul>

                                        <h3>Functional Cookies</h3>
                                        <p>These cookies enable enhanced functionality and personalization:</p>
                                        <ul>
                                            <li>Remembering your language preferences</li>
                                            <li>Storing your search history and filters</li>
                                            <li>Maintaining your login status</li>
                                            <li>Providing location-based services</li>
                                        </ul>

                                        <h3>Marketing Cookies</h3>
                                        <p>These cookies are used to deliver relevant advertisements and track marketing campaign effectiveness:</p>
                                        <ul>
                                            <li>Showing personalized ads based on your interests</li>
                                            <li>Measuring the effectiveness of advertising campaigns</li>
                                            <li>Tracking conversions and user engagement</li>
                                            <li>Providing social media features</li>
                                        </ul>

                                        <h2>3. Third-Party Cookies</h2>
                                        <p>We may use third-party services that also place cookies on your device:</p>
                                        
                                        <h3>Analytics Services</h3>
                                        <ul>
                                            <li><strong>Google Analytics:</strong> Helps us understand website traffic and user behavior</li>
                                            <li><strong>Facebook Pixel:</strong> Tracks conversions and provides advertising insights</li>
                                            <li><strong>Hotjar:</strong> Provides heatmaps and user session recordings</li>
                                        </ul>

                                        <h3>Advertising Services</h3>
                                        <ul>
                                            <li><strong>Google Ads:</strong> Delivers relevant advertisements</li>
                                            <li><strong>Facebook Ads:</strong> Provides targeted advertising</li>
                                            <li><strong>LinkedIn Ads:</strong> Offers professional networking advertisements</li>
                                        </ul>

                                        <h3>Social Media</h3>
                                        <ul>
                                            <li><strong>Facebook:</strong> Enables social sharing and login</li>
                                            <li><strong>Twitter:</strong> Provides social media integration</li>
                                            <li><strong>LinkedIn:</strong> Offers professional networking features</li>
                                        </ul>

                                        <h2>4. Cookie Duration</h2>
                                        <h3>Session Cookies</h3>
                                        <p>These cookies are temporary and are deleted when you close your browser. They are used for:</p>
                                        <ul>
                                            <li>Maintaining your session while browsing</li>
                                            <li>Storing temporary form data</li>
                                            <li>Security and authentication</li>
                                        </ul>

                                        <h3>Persistent Cookies</h3>
                                        <p>These cookies remain on your device for a set period or until you delete them. They are used for:</p>
                                        <ul>
                                            <li>Remembering your preferences</li>
                                            <li>Providing personalized content</li>
                                            <li>Analyzing long-term user behavior</li>
                                        </ul>

                                        <h2>5. Managing Your Cookie Preferences</h2>
                                        <p>You have several options for managing cookies:</p>

                                        <h3>Browser Settings</h3>
                                        <p>Most browsers allow you to:</p>
                                        <ul>
                                            <li>Block all cookies</li>
                                            <li>Block third-party cookies only</li>
                                            <li>Delete existing cookies</li>
                                            <li>Set preferences for specific websites</li>
                                        </ul>

                                        <h3>Cookie Consent</h3>
                                        <p>When you first visit our website, you'll see a cookie consent banner that allows you to:</p>
                                        <ul>
                                            <li>Accept all cookies</li>
                                            <li>Reject non-essential cookies</li>
                                            <li>Customize your cookie preferences</li>
                                            <li>Learn more about our cookie policy</li>
                                        </ul>

                                        <h3>Opt-Out Tools</h3>
                                        <p>You can also use third-party tools to manage cookies:</p>
                                        <ul>
                                            <li><strong>Your Online Choices:</strong> European opt-out portal</li>
                                            <li><strong>Network Advertising Initiative:</strong> US opt-out portal</li>
                                            <li><strong>Digital Advertising Alliance:</strong> Self-regulatory program</li>
                                        </ul>

                                        <h2>6. Impact of Disabling Cookies</h2>
                                        <p>If you choose to disable cookies, you may experience:</p>
                                        <ul>
                                            <li>Reduced website functionality</li>
                                            <li>Loss of personalized features</li>
                                            <li>Need to re-enter information repeatedly</li>
                                            <li>Less relevant advertising</li>
                                            <li>Limited access to certain features</li>
                                        </ul>

                                        <h2>7. Updates to This Policy</h2>
                                        <p>We may update this Cookie Policy from time to time to reflect:</p>
                                        <ul>
                                            <li>Changes in our cookie practices</li>
                                            <li>New technologies or services</li>
                                            <li>Legal or regulatory requirements</li>
                                            <li>User feedback and preferences</li>
                                        </ul>
                                        <p>We will notify you of any material changes by updating the "Last updated" date at the top of this policy.</p>

                                        <h2>8. Contact Us</h2>
                                        <p>If you have questions about our use of cookies or this Cookie Policy, please contact us:</p>
                                        <div className="contact-info">
                                            <div className="contact-item">
                                                <FaEnvelope className="contact-icon" />
                                                <div>
                                                    <h6>Email</h6>
                                                    <p>cookies@businessdirectory.com</p>
                                                </div>
                                            </div>
                                            <div className="contact-item">
                                                <FaPhone className="contact-icon" />
                                                <div>
                                                    <h6>Phone</h6>
                                                    <p>+1 (555) 123-4567</p>
                                                </div>
                                            </div>
                                            <div className="contact-item">
                                                <FaGlobe className="contact-icon" />
                                                <div>
                                                    <h6>Address</h6>
                                                    <p>123 Business Ave, Suite 100<br />City, State 12345</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-4 p-3 bg-light rounded">
                                            <h4>Quick Cookie Settings</h4>
                                            <p>You can quickly adjust your cookie preferences using the settings below:</p>
                                            <div className="d-flex flex-wrap gap-2">
                                                <button className="btn btn-success btn-sm">
                                                    <FaCheckCircle /> Accept All Cookies
                                                </button>
                                                <button className="btn btn-warning btn-sm">
                                                    <FaCog /> Customize Settings
                                                </button>
                                                <button className="btn btn-danger btn-sm">
                                                    <FaTimesCircle /> Reject Non-Essential
                                                </button>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default Cookies; 